import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { validate, validators } from 'validate-redux-form';
import { FormatDate } from '../../../../Utils/renderField/hookForms';
import { NumberField } from '../../../../Utils/renderField/fieldsHookForms';
import { Field, FieldArray, reduxForm, change } from 'redux-form';
import { renderSwitch } from '../../../../Utils/renderField/renderField';
import { api } from "api";
import { RenderDollar } from '../../../../Utils/renderField/renderReadField';
import './BonifAmoniacoForm.css';

/**
 * Componente para el paso de bonificación por uso de amoniaco
 * @param {object} props - Props del componente
 * @returns {JSX.Element} - Componente de formulario de bonificación por uso de amoniaco
 */
let BonifAmoniacoForm = props => {
    const { handleSubmit, previousStep } = props;
    const { control, formState: { errors }, watch, reset, trigger } = useForm();

    useEffect(() => {
        const historial_amoniaco = props.historial_amoniaco || [];

        if (historial_amoniaco.length <= 0) {
            api.get("finca_bonif_amoniaco/get_default_bonif_amoniaco").
                then((data) => {
                    props.dispatch(change('fincaForm', 'historial_amoniaco', data));
                }).catch(() => {
                    return [];
                });
        }
    }, [])

    const renderHistorial = (fieldArrayProps) => {

        const { fields, meta: { error, submitFailed } } = fieldArrayProps;
        const { valor_limite_nh3, bono_por_kilogramo } = watch();

        const AgregarRegistro = async () => {
            const camposValidos = await trigger();
            if (!camposValidos) return;

            const valor_limite_nh3_float = parseFloat(valor_limite_nh3.replace(",", ""));
            const bono_por_kilogramo_float = parseFloat(bono_por_kilogramo.replace(",", ""));

            fields.push({
                valor_limite_nh3: valor_limite_nh3_float,
                bono_por_kilogramo: bono_por_kilogramo_float,
                creado: new Date()
            });

            reset({
                valor_limite_nh3: '',
                bono_por_kilogramo: ''
            });
        }

        const historial = fields.getAll() ? [...fields.getAll()] : [];

        return (
            <div className=" col-sm-12 p-0">
                <div className="d-flex justify-content-center mt-2 mb-3">
                    <button type="button" className="btn btn-outline-info py-0" onClick={AgregarRegistro}>
                        AGREGAR
                    </button>
                </div>

                <h6 className="my-3">HISTORIAL DE CONFIGURACIÓN</h6>

                <div className="bonif-amoniaco-form__table-wrapper new-table-wrapper">
                    <table className="table mb-0">
                        <thead>
                            <tr>
                                <th>FECHA</th>
                                <th className='th--right'>VALOR LÍMITE DE NH3</th>
                                <th className='th--right'>BONO POR KILOGRAMO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historial.reverse().map((registro, index) => (
                                <tr key={index}>
                                    <td>
                                        {FormatDate(registro.creado)}
                                    </td>
                                    <td className='td--right'>
                                        {registro.valor_limite_nh3}
                                    </td>
                                    <td className='td--right td--no-wrap'>
                                        <RenderDollar value={registro.bono_por_kilogramo} decimalScale={4} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        )
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group grid-container bonif-amoniaco-form">
                <h6 className="mb-4">BONIFICACIÓN POR USO DE AMONIACO</h6>

                {/* Pregunta sobre bonificación */}
                <div className="formulario-fields-row">
                    <div className="formulario-field horizontal">
                        <label htmlFor="aplica_bonif_amoniaco">¿APLICA A BONIFICACIÓN POR AMONIACO?</label>
                        <Field name="aplica_bonif_amoniaco" component={renderSwitch} type="text" />
                    </div>
                </div>

                {/* Campos de valor límite NH3 y bono por kilogramo */}
                <div className="formulario-fields-row">
                    <div className="formulario-field">
                        <label htmlFor="valor_limite_nh3" className="m-0">VALOR LÍMITE DE NH3</label>
                        <NumberField
                            control={control}
                            name="valor_limite_nh3"
                            errors={errors}
                            allowNegative={false}
                            onEnterAction={() => trigger('valor_limite_nh3')}
                            thousandSeparator={false}
                            rules={{
                                required: "Este campo es obligatorio",
                                min: { value: 0, message: "Debe ser al menos 0" },
                                max: { value: 1, message: "Debe ser menor o igual a 1" },
                            }}
                        />
                    </div>
                    <div className="formulario-field">
                        <label htmlFor="bono_por_kilogramo" className="m-0">BONO POR KILOGRAMO</label>
                        <NumberField
                            control={control}
                            name="bono_por_kilogramo"
                            errors={errors}
                            allowNegative={false}
                            onEnterAction={() => trigger('bono_por_kilogramo')}
                            prefix="$ "
                            rules={{
                                required: "Este campo es obligatorio",
                                min: { value: 0, message: "Debe ser al menos 0" },
                                max: { value: 1, message: "Debe ser menor o igual a 1" },
                            }}
                            decimalScale={4}
                        />
                    </div>
                </div>

                <FieldArray name="historial_amoniaco" component={
                    (fieldArrayProps) => renderHistorial(fieldArrayProps)
                } />

                {/* Botones */}
                <div className="buttons-box mt-3">
                    <button type="button" className="btn btn-outline-dark mx-3 mt-3 mb-2" onClick={previousStep}>ANTERIOR</button>
                    <button type="submit" className="btn btn-primary mx-3 mt-3 mb-2">SIGUIENTE</button>
                </div>
            </div>
        </form>
    );
};

BonifAmoniacoForm = reduxForm({
    form: 'fincaForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate: data => {
        return validate(data, {
            'nombre': validators.exists()('Campo requerido.'),
        })
    }
})(BonifAmoniacoForm);


BonifAmoniacoForm = connect(state => {
    const fincaForm = state.form.fincaForm;

    if (fincaForm && fincaForm.values) {
        const values = fincaForm.values;
        const { historial_amoniaco } = values;

        return {
            historial_amoniaco
        }
    } else {
        return {}
    }
})(BonifAmoniacoForm)

export default BonifAmoniacoForm
